<template>
  <div class="s-page">
    <div style="width: 1200px;margin: 0 auto;margin-bottom: 20px;">
      <div :class="'item' + (rankParams.title === '青少组' ? ' active':'')" @click="handleTeam('青少组', '小学组')">青少组</div>
      <div :class="'item' + (rankParams.title === '成年组' ? ' active':'')" @click="handleTeam('成年组', '甲组')">成年组</div>
      <div :class="'item' + (rankParams.title === '老年组' ? ' active':'')" @click="handleTeam('老年组', '-1')">老年组</div>
      <div :class="'item' + (rankParams.title === '残疾人运动组' ? ' active':'')" @click="handleTeam('残疾人运动组', '-1')">残疾人运动组</div>
    </div>
    <div class="select">
        <a-select  style="width: 160px;margin-right:20px" @change="handleProgram" placeholder="选择比赛项目">
          <a-select-option :value="-1">全部</a-select-option>
            <a-select-option :value="item.id"  v-for="(item,index) in seriesProgram" :key="index">
                {{item.name}}
            </a-select-option>
        </a-select>
        <a-input style="width: 160px;margin-right:20px" placeholder="请输入代表团名称" @change="handleAgency" />
        <!-- <a-select v-model="rankParams.title" style="width: 160px;margin-right:20px" @change="handleTeam" placeholder="选择分组">
          <a-select-option :value="-1">全部</a-select-option>
            <a-select-option  :value="item.title" v-for="(item,index) in seriesGroup" :key="index">
                {{item.title}}
            </a-select-option>
        </a-select> -->
        <a-select v-if="rankParams.groupName !== '-1'" v-model="rankParams.groupName" style="width: 160px;margin-right:20px" @change="handleGroup" placeholder="选择组别">
          <!-- <a-select-option :value="-1">全部</a-select-option> -->
            <a-select-option  :value="item" v-for="(item,index) in sportGroup" :key="index">
                {{item}}
            </a-select-option>
        </a-select>
    </div>
    <RankingScore @rowClick="rowClick" :medalList="medalList" :rankParams="rankParams" :total="total" @handlePage="handlePage"/>
  </div>
</template>

<script>
import RankingScore from '@district/components/home/RankingScore.vue'
export default {
  components: {
    RankingScore,
  },
  data () {
    return {
      medalList:[],
      rankParams:{
        pageSize:20,
        pageNum:1,
        programId:-1,
        agencyName:-1,
        title: '青少组',
        groupName: '小学组'
      },
      programId:-1,
      agencyId:-1,
      total:0,
      seriesProgram:[],
      seriesAgency:[],
      seriesGroup:[],//赛事分组
      sportGroup: []
    }

  },
  mounted () {
    this.getFindSeriesRankList()
    this.getSeriesProgram()
    this.getSeriesAgency()
    this.getSeriesGroupName()
    this.findSportGroupName('青少组')
  },
  methods: {
    //选择
    handleTeam (title, type){
      this.rankParams.title=title
      this.rankParams.groupName=type
      this.findSportGroupName(title)
      this.getFindSeriesRankList()
    },
    //选择
    handleGroup (title){
      this.rankParams.groupName=title
      this.getFindSeriesRankList()
    },
    //选择项目
    handleProgram (programId) {
      this.rankParams.programId=programId
      this.getFindSeriesRankList()
    },
    //选择代表团
    handleAgency (e) {
      console.log(e.target.value)
      if (e.target.value === '') {
        this.rankParams.agencyName = -1
      } else {
        this.rankParams.agencyName = e.target.value
      }
      
      this.getFindSeriesRankList()
    },
    rowClick (item) {
      this.$emit('medalRowClick', item)
    },
    //所有分组
    async getSeriesGroupName () {
      try {
        let res =await this.$api.district.seriesGroupName()
        console.log('seriesGroupName',res)
        if(res.status==0){
          this.seriesGroup=res.data
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    //所有分组
    async findSportGroupName (title) {
      try {
        let res =await this.$api.district.findSportGroupName(title)
        console.log('seriesGroupName',res)
        if(res.status==0){
          this.sportGroup=res.data
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    //所有奖牌数据
    async getFindSeriesRankList () {
      try {
        let res =await this.$api.district.seriesMedalRanking(this.rankParams)
        if(res.status==0){
          this.medalList=res.data
          this.total=res.total
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    //所有比赛项目
    async getSeriesProgram (){
      try {
        let res =await this.$api.district.seriesProgram()
        if(res.status==0){
          this.seriesProgram=res.data
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    //所有代表团
    async getSeriesAgency (){
      try {
        let res =await this.$api.district.seriesAgency()
        if(res.status==0){
          this.seriesAgency=res.data
        }else{
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    handlePage (page, pageSize){
      this.rankParams.pageNum=page
      this.rankParams.pageSize=pageSize
      this.getFindSeriesRankList()
    }
  },
}
</script>

<style lang="scss" scoped>
.s-page{
    width: 100%;
    background-color: #FBFBFB;
    border-top: 1px solid #E4E4E4;
    padding-top: 30px;
    margin-bottom: 30px;
    .select{
        width: 1200px;
        margin: 0 auto;
        height: 80px;
        background: #FFFFFF;
        box-shadow: 0px 2px 6px 0px rgba(33,26,30,0.08);
        border-radius: 10px;
        margin-bottom: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 30px;
    }
    .item{
      padding: 20px 30px;
      background: #eeee;
      color: black;
      display: inline-block;
      border-radius: 5px;
      cursor: pointer;
    }
    .active{
      background: #009EDF;
      color: white;
    }
}
</style>



// WEBPACK FOOTER //
// src/district/views/schedule/components/RankingScore.vue